module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/arrow-from-top-a563a3d47efa92a392c0fd557e009853.svg";